import { ThemeProperties } from '../../core';

export interface DropdownMenuTheme {
	contentBackground: string;
	contentBorderColor: string;
	contentBorderRadius: string;
	contentBoxShadow: string;

	itemFont: string;
	itemFontColor: string;
	itemBorderRadius: string;
	itemMinHeight: string;
	itemPadding: string;
	itemHoverBackground: string;
	itemActiveBackground: string;
	itemDisabledBackground: string;
}

export const theme = new ThemeProperties('dropdownMenu');
